import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setBroadcastMessageDismissed } from 'store/broadcastMessages/actions';
import { getBroadcastMessages } from 'store/broadcastMessages/selectors';
import { BroadcastBanner } from 'components/BroadcastBanner/BroadcastBanner';
import { BROADCAST_MESSAGE_CATEGORY } from 'utils/constants';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { setIsLoginModalOpen } from 'store/auth/actions';

export const BroadcastBannerStack: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const customActionMap = new Map([
    [
      BROADCAST_MESSAGE_CATEGORY.INCOMPLETE_PROFILE,
      {
        label: t('profilePage:incompleteProfileWarningDashboard.action'),
        onClick: () => navigate('/auth/profile/'),
      },
    ],
  ]);

  const customMessageMap = new Map([
    [
      BROADCAST_MESSAGE_CATEGORY.LOGIN,
      <div className="flex-grow" key="login-message">
        <Trans
          i18nKey={'guestPayments:header.content'}
          components={{
            loginLink: (
              <a
                className="underline"
                href="#"
                onClick={() => {
                  dispatch(setIsLoginModalOpen(true));
                }}
              />
            ),
          }}
        />
      </div>,
    ],
  ]);

  const broadcastMessages = useSelector(getBroadcastMessages).map((broadcastMessage) => ({
    ...broadcastMessage,
    action: broadcastMessage.action ?? customActionMap.get(broadcastMessage.category),
    message: broadcastMessage.message ?? customMessageMap.get(broadcastMessage.category),
  }));

  const broadcastMessageToDisplay = broadcastMessages[0];

  return (
    <div data-cy="broadcast-banner">
      {broadcastMessageToDisplay && (
        <BroadcastBanner
          message={broadcastMessageToDisplay.message}
          action={broadcastMessageToDisplay.action}
          type={broadcastMessageToDisplay.type}
          closeButtonOnClick={() => dispatch(setBroadcastMessageDismissed(broadcastMessageToDisplay.uuid))}
        />
      )}
    </div>
  );
};
